







































import { Vue, Component, Prop, Ref } from 'vue-property-decorator'
import ModalDialog from 'components/modals/Dialog.vue'

@Component({
  components: {
    ModalDialog
  }
})
export default class ItemCourseGradebookSettingsButtonRetakes extends Vue {

  @Prop()
  readonly value!: string | null

  @Ref()
  readonly dialog!: ModalDialog

  get label () {
    switch (this.value || '') {
      case 'last': return this.$t('item.course.gradebook.retakes.last').toString()
      case 'max': return this.$t('item.course.gradebook.retakes.max').toString()
      case 'avg': return this.$t('item.course.gradebook.retakes.avg').toString()
      default: return this.$t('item.course.gradebook.retakes.first').toString()
    }
  }

  action (value: string | null) {
    this.dialog.hide()
    this.$emit('input', value)
  }
}
